import { Component, Layout, Textbox, TooltipContent } from "@mcleod/components";
import { Alignment, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutDeclineDetails } from "./autogen/AutogenLayoutDeclineDetails";
import { AutogenLayoutEdiDeclineCodeQuickInfo } from "./autogen/AutogenLayoutEdiDeclineCodeQuickInfo";
import { ModelEdiorderProfile } from "./models/ModelEdiorderProfile";

export class DeclineDetails extends AutogenLayoutDeclineDetails {
    version: string;
    selectedReason: string;
    partnerId: string;
    mainRow: any;

    override onLoad() {
        this.mainDataSource.data[0] = this.mainRow;
        this.mainDataSource.rowIndex = 0;

        new ModelEdiorderProfile().searchSingle({ partner_id: this.partnerId, version: this.version }).then(row => {
            if (row && row.get("decl_req_reason") === "Y") {
                this.reasonTextbox.required = true;
                this.reasonTextbox.placeholder = "Required";
            }
        });

        this.reasonTextbox.addBeforeLookupModelSearchListener(event => {
            event.filter.partner_id = this.partnerId;
            event.filter.version = this.version;
        });

        this.setupReasonQuickInfo();
    }

    private setupReasonQuickInfo() {
        this.reasonTextbox.quickInfoOverrideMethod = async (): Promise<Component> => {
            const dataRow: ModelRow = this.reasonTextbox.lookupModelData?.[0] as ModelRow;
            if (dataRow?.get("standard_code") != null) {
                const layout =
                    await Layout.getLoadedLayout("lme/datafusion/EDIDeclineCodeQuickInfo") as AutogenLayoutEdiDeclineCodeQuickInfo;
                layout.textboxReasonCode.text = dataRow.get("standard_code");
                layout.textboxDescription.text = dataRow.get("description");
                layout.textboxVersion.text = dataRow.get("version");
                layout.textboxElementID.text = dataRow.get("element_id");
                return layout;
            }
        }
    }
}
